import script from "./ResultsBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsBox.vue?vue&type=script&setup=true&lang=js"

import "./ResultsBox.vue?vue&type=style&index=0&id=61a8bf5f&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\MKTracker\\mk-tracker\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a8bf5f"]])

export default __exports__